import * as React from 'react'

function SvgBj(props) {
	return (
		<svg viewBox="0 0 15 10" width="1em" height="1em" {...props}>
			<path fill="#E8112D" d="M0 0h15v10H0z" />
			<path fill="#FCD116" d="M0 0h15v5H0z" />
			<path fill="#008751" d="M0 0h6v10H0z" />
		</svg>
	)
}

export default SvgBj
